import React from "react";
import { useTranslation } from "react-i18next";

export const SoftwareDevelopmentAbout = () => {
  const { t } = useTranslation();

  return (
    <div id="soft-dev">
      <div  className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{t("t-SoftwareDevelopment")}</h2>
              <p style={{marginTop: '0px'}}>
                {t("t-SoftwareServiceIntro01")}
                <br/>
                <br/>
                {t("t-SoftwareServiceIntro02")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
